// React
import React, { createContext, useMemo, useContext } from "react";
import PropTypes from "prop-types";
// Helpers
import { merge } from "@mefisto/utils";

////////////////////////////////////////////////////
/// Context
////////////////////////////////////////////////////

const Context = createContext({});

export const useNavigationLayout = (componentProps = {}) => {
  const contextProps = useContext(Context);
  const props = useMemo(() => {
    return merge({}, contextProps, componentProps);
  }, [contextProps, componentProps]);
  return props;
};

////////////////////////////////////////////////////
/// Component
////////////////////////////////////////////////////

const NavigationLayoutProvider = ({ layoutProps = {}, children }) => (
  <Context.Provider value={layoutProps}>{children}</Context.Provider>
);

NavigationLayoutProvider.propTypes = {
  layoutProps: PropTypes.object,
  children: PropTypes.node,
};

export default NavigationLayoutProvider;
